<template>
  <div class="search-filters-container">
    <v-text-field
      ref="textField"
      v-model="searchQuery"
      variant="outlined"
      density="compact"
      hide-details
      :placeholder="selected?.length ? '' : placeholder"
      :disabled="disabled"
      class="input-field full-width"
      @keydown.delete="$emit('deleteKeyDown')"
      @focus="$emit('focus')"
    >
      <template
        v-if="selected.length || isSelect"
        #append-inner
      >
        <v-icon
          v-if="isSelect"
          color="grey900"
          class="chevron-icon"
          size="small"
          :icon="opened ? '$chevron-up' : '$chevron-down'"
          @click.self="$emit('toggleDropdown')"
        />
      </template>
    </v-text-field>
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: 'Select',
  },
  selected: {
    type: Array,
    default: () => ([]),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  async: {
    type: Boolean,
    default: false,
  },
  isSelect: {
    type: Boolean,
    default: false,
  },
  opened: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits([
  'update:selectedFilters',
  'update:modelValue',
  'deleteKeyDown',
  'toggleDropdown',
  'focus',
]);

const searchQuery = computed({
  get: () => props.modelValue,
  set: (value) => emits('update:modelValue', value),
});

const textField = ref(null);

onMounted(() => {
  if (!props.isSelect) textField.value.focus();
});
</script>

<style lang="less" scoped>
.search-filters-container {
  width: 100%;
}

.input-field {
  width: 100%;
  height: 32px;
  min-height: 32px;
}

:deep(.v-field) {
  display: flex;
  flex-wrap: wrap;
  min-width: 215px;
  height: 32px;
  padding-right: 8px;
  font-size: 12px;
  background-color: @bg-canvas;
  border: 1px solid @stroke-default;

  input, input::placeholder {
    opacity: 1;
    color: @text-lighter;
    font-size: 12px;
    font-weight: 500;
    min-height: 32px;
    padding-top: 0px;
    padding-bottom: 0px;
  }

  input {
    color: @text-darkest;
    font-weight: 500 !important;
  }

  .v-field__outline {
    display: none;
  }
}

:deep(.chevron-icon) {
  transform: translateY(-1px);
}
</style>
